<template>
  <div class="jom-glossary" id="glossary" v-if="this.glossary && this.glossary.data.length > 0">
    <h2 v-if="glossary.title && glossary.title != ''" class="theme-background">
      {{glossary.title}}
    </h2>
    <h2 class="theme-background" v-else>{{ARTICLE.defaultlang === 'zh' ? '符号说明' : 'Symbol Definition'}}</h2>
    <table>
      <thead>
      <tr>
        <th align="right">{{ARTICLE.defaultlang === 'zh' ? '符号' : 'Symbol'}}</th>
        <th>——</th>
        <th align="left">{{ARTICLE.defaultlang === 'zh' ? '符号说明' : 'Definition'}}</th>
      </tr>
      </thead>
      <tbody v-for="item in this.glossary.data">
      <tr v-if="item.title" style="font-weight: bold">
        <td align="left" colspan="3">
          <component :is="'jo' + item2.name" v-for="item2 in item.title" v-bind:key="item2.index" v-bind:data="item2.data"></component>
        </td>
      </tr>
      <tr v-if="item.deflist.length>0" v-for="i in item.deflist">
        <td align="right"><component :is="'jo' + info.name" v-for="info in i.term" v-bind:key="info.index"
                                     v-bind:data="info.data"></component></td>
        <td>——</td>
        <td>
          <component :is="'jo' + info.name" v-for="info in i.def" v-bind:key="info.index"
                     v-bind:data="info.data"></component>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  import jomath from './../formula/math.vue'
  export default {
    components: {
      jomath
    },
    props: [
        'data'
    ],
    data () {
      return {
        width: 10,
        glossary: this.ARTICLE.glossary
      }
    },
    created () {

    }
  }
</script>
<style lang="scss">
    .jom-glossary {
      font-size: 1.4rem;
      table{
        margin: 20px auto 25px;
        border: none;
        border-top: 2px solid #333333;
        border-bottom: 2px solid #333333;
        border-collapse:collapse;
        thead{
          tr{
            height: 17px;
            line-height: 17px;
            border-bottom: 0.6px solid #333333;
            font-weight: bold;
            th{
              line-height: 17px;
              padding: 5px;
            }
          }
        }

        tbody{
          tr{
            height: 16px;
            line-height: 16px;
            td{
              padding: 5px;
            }
          }
        }
      }
    }
</style>



// WEBPACK FOOTER //
// src/componentsMobile/maincontent/body/glossary/glossary.vue